import { render, staticRenderFns } from "./tag_domain_toggle_btn.vue?vue&type=template&id=83e0c400&lang=pug&"
import script from "./tag_domain_toggle_btn.vue?vue&type=script&lang=js&"
export * from "./tag_domain_toggle_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports